import { createMemo } from 'solid-js'
import { EVENT_END_MS } from '~/config'
import { useTimestamp } from './use-timestamp'

export interface Countdown {
  days: number
  hours: number
  minutes: number
  done: boolean
}

export function computeCountdown(targetMs: number, nowMs: number): Countdown {
  const diff = targetMs - nowMs
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, done: true }
  const minutes = Math.floor(diff / 60_000) % 60
  const hours = Math.floor(diff / 3_600_000) % 24
  const days = Math.min(99, Math.floor(diff / 86_400_000))
  return { days, hours, minutes, done: false }
}

export function useCountdown() {
  const timestamp = useTimestamp()
  // `timestamp.data` is undefined until the cache is seeded or the first
  // refetch lands; treat that as "not anchored" so the countdown stays hidden.
  return createMemo(() => {
    const nowMs = timestamp.data
    if (typeof nowMs !== 'number' || nowMs <= 0) {
      return { days: 0, hours: 0, minutes: 0, done: true }
    }
    return computeCountdown(EVENT_END_MS, nowMs)
  })
}
